import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { ErrorHandler, withMedia } from '@playbookux/playbook-web-core';
import { compose } from 'redux';
import { GET_ATTACHMENT } from './graphql';
import VideoPlayer from '../../../../core/components/video-player';
import {
  Container,
  Loader,
  VideoContainer,
  ContainerMessage,
  MessageImage,
  Message,
  CenterContent,
} from './styles';
import ControlBarSpacer from '../../../../core/components/video-player/control-bar-spacer';
import withLayout from '../../../../core/components/with-layout';

const ViewAttachment = () => {
  const { attachmentId } = useParams();
  const [videoError, setVideoError] = useState(null);

  const { data, loading, error } = useQuery(GET_ATTACHMENT, {
    variables: { id: attachmentId },
  });

  if (loading) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }

  if (error) {
    return (
      <ErrorHandler
        error={error}
        defaultMessage="Error while retrieving attachment."
      />
    );
  }

  if (videoError) {
    return (
      <ContainerMessage>
        <CenterContent>
          <MessageImage src="/images/cross-icon.png" />
          <Message>
            This video is corrupted or incompatible.
          </Message>
        </CenterContent>
      </ContainerMessage>
    );
  }

  const { attachment } = data;

  return (
    <Container>
      <VideoContainer>
        {attachment && (
          <VideoPlayer
            src={attachment.filePath}
            onError={(err) => setVideoError(err)}
          >
            <ControlBarSpacer
              beforeElement="downloadButton"
            />
          </VideoPlayer>
        )}
      </VideoContainer>
    </Container>
  );
};

const enhance = compose(
  withMedia,
  withLayout(),
);

export default enhance(ViewAttachment);
